import { render, staticRenderFns } from "./tap-company-customer.vue?vue&type=template&id=99b471a8"
import script from "./tap-company-customer.vue?vue&type=script&lang=js"
export * from "./tap-company-customer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports